
import React from 'react';
import * as Components from './form_components.jsx';

function Resolver() {
  // Resolve component class name from type string
  this.componentClassName = (type) => {
      if (!this.componentTypeToClassNameCache) {
          this.componentTypeToClassNameCache = {};
          this.componentClassNames().forEach((name) => {
              this.componentTypeToClassNameCache[Components[name].TYPE] = name;
          });
      }
      return this.componentTypeToClassNameCache[type];
  }


  // Resolve component class from type string
  this.componentClass = (type) => {
      return Components[this.componentClassName(type)];
  }


  this.componentClassNames = () => {
      if (!this.componentClassNamesCache) {
          this.componentClassNamesCache = Object.keys(Components).filter((k) => {
              return k != 'Base' && typeof Components[k].defaultContent == 'function';
          });
      }
      return this.componentClassNamesCache;
  }


  // Factory method for creating FormComponents based on type string
  this.createElement = (type, props) => {
      let cClass = this.componentClass(type);
      return cClass ? React.createElement(cClass, props) : null;
  }
}

const resolver = new Resolver();
export default resolver;